<template>
  <div class="container main" style="margin-top:0;padding-top:0">
    <div class="row">
      <div class="twelve columns">
        <br><br>
        <h1 class="h4" style="margin-bottom:15px;margin-top:0">{{ listTitle }}</h1>
        <div id="adm-form-wrapper">
          <form id="adm-form" @submit="triggerSearch">
            <div class="row">
              <div class="six columns">
                <label>Keyword Search</label>
                <input name="term" type="text" id="term" class="u-full-width" v-model="term" placeholder="Keyword: e.g. Container, Drill...">
              </div>
              <div class="three columns">
                <label>&nbsp;</label>
                <input type="button" name="btnSearch" value="Find Equipment" id="btnSearch" class="button-primary u-full-width" v-on:click="search">
              </div>
              <div class="three columns">
                <label>&nbsp;</label>
                <input type="button" name="Reset" value="Reset" id="Reset" class="button-primary u-full-width" v-on:click="reset">
              </div>
            </div>
            <div class="row">
              <div class="six columns">
                <label>Category</label>
                <select name="category" id="category" class="u-full-width" v-model="category" @change="categoryChange($event)">
                  <option value="All">All</option>
                  <option v-for="(cat, catIndex) in categories" :key="catIndex" :value="cat.CategoryID">{{ cat.CategoryName }}</option>
                </select>
                <br>
                <label>Make</label>
                <select name="make" id="make" class="u-full-width" v-model="make" @change="makeChange($event)">
                  <option value="All">All</option>
                  <option v-for="(make, makeIndex) in makes" :key="makeIndex" :value="make.Make">{{ make.Make }}</option>
                </select>
              </div>
              <div class="six columns">
                <label>Sub-Category</label>
                <select name="subCategory" id="subCategory" class="u-full-width" v-model="subcategory">
                  <option value="All">All</option>
                  <option v-for="(subcat, subcatIndex) in subCategories" :key="subcatIndex" :value="subcat.SubCategoryID">{{ subcat.SubCategoryName }}</option>
                </select>
                <br>
                <label>Model</label>
                <select name="model" id="model" class="u-full-width" v-model="model">
                  <option value="All">All</option>
                  <option v-for="(submake, submakeIndex) in subMakes" :key="submakeIndex" :value="submake.Model">{{ submake.Model }}</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <Loader v-if="loading" />
        <div :class="`isotope-loading-${ loading }`">
          <isotope id="equipment" class="grid" ref="isotope" :options="isotopeOptions" :list="equipments" v-images-loaded="loaded" v-if="equipments.length">
            <div class="grid-item" v-for="(equipment, equipmentIndex) in equipments" :key="equipmentIndex">
              <div class="item-pad">
                <a :href="`${ baseURL }equipment=${ equipment.EquipmentID }`">
                <div class="box">
                  <VueSkeletonLoader :width="'100%'" :height="'200px'" v-show="imgLoading" />
                  <img :src="`${ source }/f/${ data }/equipment/${ equipment.EquipmentID }/merge/1.jpg`" :alt="`${ equipment.WebsiteTitle }`" :title="`${ equipment.WebsiteTitle }`" style="width:100%" v-show="!imgLoading">
                  <div class="ribbon" v-if="equipment.StatusID == 6"><span>SOLD</span></div>
                  <div class="ribbon-yellow" v-if="equipment.StatusID == 8"><span>UNDER OFFER</span></div>
                  <div class="ribbon-green" v-if="equipment.StatusID == 10"><span>COMING SOON</span></div>
                  <div class="ribbon-blue" v-if="equipment.AuctionLink"><span>AUCTION</span></div>
                </div>
                <b>{{ equipment.WebsiteTitle }}</b></a><br>
                <p><span v-html="equipment.WebsiteDescription"></span>...<a :href="`${ baseURL }equipment=${ equipment.EquipmentID }`">read more</a>
                   <br>
                   <span class="links"> 
                    <span v-if="equipment.EquipmentID"><a :href="`${ baseURL }equipment=${ equipment.EquipmentID }`" target="_parent">Photos</a> &nbsp;&nbsp;</span>
                    <span v-if="equipment.EquipmentID"><a href="#" v-on:click.prevent="downloadFlyer(equipment.EquipmentID)">Flyer</a> &nbsp;&nbsp;</span>
                    <span v-if="equipment && equipment.AuctionLink"><a :href="`${ equipment.AuctionLink }`" target="_blank">Auction</a> &nbsp;&nbsp;</span>
                    <span v-if="equipment && equipment.YouTubeID"><a :href="`${ baseURL }equipment=${ equipment.EquipmentID }`" target="_parent">Video</a></span>
                   </span>
                </p>
              </div>
            </div>
          </isotope>
        </div>
        <div class="grid" v-if="!equipments.length && !loading">
          <p>No matching results found.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
#adm-widget-wrapper .ribbon-blue {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}
#adm-widget-wrapper .ribbon-blue span {
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 100px;
  display: block;
  background: #034db1;
  background: linear-gradient(#034db1,#034db1);
  box-shadow: 0 3px 10px -5px #000;
  position: absolute;
  top: 19px;
  right: -21px;
}
#adm-widget-wrapper .ribbon-blue span:after, 
#adm-widget-wrapper .ribbon-blue span:before {
  content: "";
  position: absolute;
  top: 100%;
  z-index: -1;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #034db1;
}
#adm-widget-wrapper .ribbon-blue span:before {
  left: 0;
  border-left: 3px solid #034db1;
  border-right: 3px solid transparent;
}
#adm-widget-wrapper .ribbon-blue span:after {
  right: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid #034db1;
}
</style>
<script>
import isotope from 'vueisotope';
import imagesLoaded from 'vue-images-loaded';
import VueSkeletonLoader from 'skeleton-loader-vue';
import Loader from './Loader.vue';

export default {
  name: 'Listing',
  directives: {
    imagesLoaded
  },
  components: {
    isotope,
    VueSkeletonLoader,
    Loader
  },
  props: [
    'data',
    'source',
    'type'
  ],
  data() {
    return {
      loading: true,
      imgLoading: true,
      baseURL: '',
      equipments: [],
      categories: [],
      makes: [],
      subCategories: [],
      subMakes: [],
      term: '',
      category: 'All',
      make: 'All',
      subcategory: 'All',
      model: 'All',
      listTitle: '',
      isotopeOptions: {
        percentPosition: true,
        transitionDuration: '0.4s'
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init () {
      this.listTitle = this.type == 'wanted' ? 'Wanted' : 'For Sale';
      this.listTitle = this.type == 'forhire' ? 'For Hire' : this.listTitle;

      const categories = await fetch(this.source + '/web/categories-json.aspx?c=' + this.data);
      this.categories = await categories.json();

      const makes = await fetch(this.source + '/web/makes-json.aspx?c=' + this.data);
      let arrMakes = await makes.json();
      this.makes = arrMakes.Makes;

      let currentUrl = window.location.pathname;
      this.baseURL = ( currentUrl.includes("?") )  ? currentUrl + '&' : currentUrl + '?';

      this.search();
    },
    async categoryChange(event) {
      const subCategories = await fetch(this.source + '/web/subcategories-json.aspx?c=' + event.target.value);
      let arrsubCategories = await subCategories.json();
      this.subCategories = arrsubCategories.SubCategories;
      this.subcategory = 'All';
    },
    async makeChange(event) {
      const subMakes = await fetch(this.source + '/web/models-json.aspx?c=' + this.data + '&m=' + event.target.value);
      let arrsubMakes = await subMakes.json();
      this.subMakes = arrsubMakes.Models;
      this.model = 'All';
    },
    async search () {
      this.loading = true;
      
      let sourceType = this.type == 'wanted' ? 'wanted' : 'forsale';
      sourceType = this.type == 'forhire' ? 'forhire' : sourceType;

      let requestURL = this.source + '/web/' + sourceType + '-json.aspx?c=' + this.data;
      requestURL += (this.term) ? '&term=' + encodeURI(this.term) : '';
      requestURL += (this.category) ? '&category=' + encodeURI(this.category) : '';
      requestURL += (this.make) ? '&make=' + encodeURI(this.make) : '';
      requestURL += (this.subcategory) ? '&subcategory=' + encodeURI(this.subcategory) : '';
      requestURL += (this.model) ? '&model=' + encodeURI(this.model) : '';

      const results = await fetch(requestURL);
      let arrResults = await results.json();
      if ( arrResults.Equipment.length ) {
        this.equipments = arrResults.Equipment;
        this.loading = false;
      }
      else {
        this.equipments = [];
        this.loading = false;
      }
    },
    triggerSearch(e) {
      e.preventDefault();
      this.search();
    },
    reset () {
      this.term = '';
      this.category = 'All';
      this.make = 'All';
      this.subcategory = 'All';
      this.model = 'All';

      this.search();
    },
    loaded () {
      let _this = this;
      _this.imgLoading = false;
      setTimeout(function() {
        _this.$refs.isotope.layout('masonry');
      }, 100);
      
    },
    async downloadFlyer (equipment) {
        let url = this.source + '/ForSaleFlyer.aspx?c=' + this.data + '&id=' + equipment;
        await fetch(url)
        .then(response => response.blob())
        .then(blob  => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = 'flyer-'+equipment+'.pdf';
            document.body.appendChild(a);
            a.click();    
            a.remove(); 
        }).catch(console.error);
    }
  }
}
</script>
